import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  numberPercent: {
    id: 'BreakdownBlock.numberPercent',
    defaultMessage: '{number}<span>%</span>',
  },
});
